import React from 'react'
import styles from './LbCTA.module.css'
import { motion } from 'framer-motion'
import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router'

const LbCTA = () => {
    return (
        <section className={styles.ctaSection}>
            <motion.div
                className={styles.container}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
            >
                <motion.h2
                    className={styles.heading}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    Connect your website to your CRM in seconds
                </motion.h2>

                <motion.p
                    className={styles.subtext}
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                >
                    Start syncing appointments, leads, and enquiries effortlessly with LeadBridge.
                </motion.p>

                <Link
                    to="/leadbridge/get-started"
                    className={styles.ctaButton}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Get Started Now <FaArrowRight className={styles.icon} />
                </Link>
            </motion.div>
        </section>
    )
}

export default LbCTA
